export default __webpack_public_path__ + "static/media/report-analytics.11cbc11d.png";